(function () {
  function hideCookieConsent() {
    var roots = [document];
    var seen = [];

    while (roots.length) {
      var scope = roots.shift();
      if (!scope || seen.indexOf(scope) !== -1) continue;
      seen.push(scope);

      var candidates = scope.querySelectorAll
        ? scope.querySelectorAll('shopify-privacy-banner,[role="alertdialog"],[role="dialog"],iframe[title*="cookie" i],iframe[title*="consent" i],iframe[src*="privacy" i]')
        : [];

      candidates.forEach(function (candidate) {
        var text = ((candidate.textContent || '') + ' ' + (candidate.getAttribute('aria-label') || '') + ' ' + (candidate.getAttribute('title') || '')).toLowerCase();
        var source = (candidate.getAttribute('src') || '').toLowerCase();
        var isConsent = text.indexOf('cookie consent') !== -1 || text.indexOf('manage preferences') !== -1 || text.indexOf('cookie') !== -1 || source.indexOf('privacy') !== -1;
        if (!isConsent) return;

        candidate.style.setProperty('display', 'none', 'important');
        candidate.setAttribute('aria-hidden', 'true');

        if (scope.host) {
          scope.host.style.setProperty('display', 'none', 'important');
          scope.host.setAttribute('aria-hidden', 'true');
        }
      });

      if (!scope.querySelectorAll) continue;
      scope.querySelectorAll('*').forEach(function (element) {
        if (element.shadowRoot) roots.push(element.shadowRoot);
      });
    }
  }

  function initBlysEmotional(root) {
    if (!root || root.dataset.blysReady === 'true') return;
    root.dataset.blysReady = 'true';
    document.documentElement.classList.add('blys-roommate-listicle-page');
    document.body.classList.add('blys-roommate-listicle-page');
    hideCookieConsent();
    [250, 750, 1500, 3000].forEach(function (delay) {
      window.setTimeout(hideCookieConsent, delay);
    });

    root.querySelectorAll('[data-blys-faq-button]').forEach(function (button) {
      button.addEventListener('click', function () {
        var item = button.closest('[data-blys-faq]');
        if (!item) return;
        var willOpen = !item.classList.contains('is-open');
        item.classList.toggle('is-open', willOpen);
        button.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
    });

    root.querySelectorAll('a[href*="start.tryamie.com/start/blys"]').forEach(function (link) {
      link.addEventListener('click', function () {
        if (!window.Shopify || !window.Shopify.analytics || typeof window.Shopify.analytics.publish !== 'function') return;
        window.Shopify.analytics.publish('blys_listicle_cta_clicked', {
          angle: root.dataset.blysAngle || 'unknown',
          placement: link.dataset.ctaPlacement || 'unknown'
        });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-blys-emotional-listicle]').forEach(initBlysEmotional);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
